/**
 * @typedef {Object} Point
 * @property {number} x - X coordinate
 * @property {number} y - Y coordinate
 */

/**
 * @typedef {Object} BezierPath
 * @property {Point} start - Starting point
 * @property {Point} control1 - First control point
 * @property {Point} control2 - Second control point
 * @property {Point} end - Ending point
 */

/**
 * @typedef {Object} UnicornConfig
 * @property {number} id - Unique identifier
 * @property {BezierPath} path - The bezier path to follow
 * @property {number} duration - Animation duration in ms
 * @property {number} delay - Start delay in ms
 * @property {number} size - Unicorn size in pixels
 */

/**
 * @typedef {'solo' | 'stampede'} CelebrationMode
 */

/**
 * @typedef {Object} CelebrationState
 * @property {boolean} isActive - Whether celebration is active
 * @property {CelebrationMode} mode - solo or stampede
 * @property {UnicornConfig[]} unicorns - Array of unicorn configs
 * @property {boolean} isFadingOut - Whether fading out
 */

// Rainbow colors for the trail
var RAINBOW_COLORS = [
  '#FF0000', // Red
  '#FF7F00', // Orange
  '#FFFF00', // Yellow
  '#00FF00', // Green
  '#0000FF', // Blue
  '#4B0082', // Indigo
  '#9400D3', // Violet
];

// Animation constants
var ANIMATION_DURATION_MIN = 2000; // 2 seconds
var ANIMATION_DURATION_MAX = 3000; // 3 seconds
var FADE_OUT_DURATION = 200; // 200ms fade out
var AUTO_DISMISS_DELAY = 500; // 500ms pause before auto-dismiss
var UNICORN_SIZE = 100; // pixels
var TRAIL_LENGTH = 150; // pixels
var STAMPEDE_MIN = 5;
var STAMPEDE_MAX = 10;

module.exports = {
  RAINBOW_COLORS: RAINBOW_COLORS,
  ANIMATION_DURATION_MIN: ANIMATION_DURATION_MIN,
  ANIMATION_DURATION_MAX: ANIMATION_DURATION_MAX,
  FADE_OUT_DURATION: FADE_OUT_DURATION,
  AUTO_DISMISS_DELAY: AUTO_DISMISS_DELAY,
  UNICORN_SIZE: UNICORN_SIZE,
  TRAIL_LENGTH: TRAIL_LENGTH,
  STAMPEDE_MIN: STAMPEDE_MIN,
  STAMPEDE_MAX: STAMPEDE_MAX,
};
